export default __webpack_public_path__ + "static/media/like.a4d2a5c3.svg";